/// <reference types="vitest" />

import { ICurrencyConversionService, ILocalizedContentService } from '@studyportals/portal-localized-content';

let localizedContentService!: ILocalizedContentService;
let currencyConversionService!: ICurrencyConversionService;

export default {
	currencyConversionService,
	localizedContentService
};
